module.exports = __webpack_public_path__ + "media/toolkits/COVID-mobile-ecosystem-924f21a3.jpg";